// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add your styles here */
/* 1. Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* 2. Remove default margin */
*:not(dialog) {
  margin: 0;
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  /* 4. Add accessible line-height */
  line-height: 1.5;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
}

/* 6. Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* 8. Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
  cursor: default;
}

/* 9. Improve line wrapping */
p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

:root {
  font-size: 16px;
  --far-background-color: white;
  --close-background-color: #eeeeee;
  --primary-color: #020100;
  --secondary-color: #801a86;
  --accent-color: #e768f3;
}
body {
  font-family: "Space Grotesk", sans-serif;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0;
    position: relative;
    min-height: 100vh;
    background-color: var(--far-background-color);
    overflow-x: hidden;
}
body::before {
    content: "";
    position: fixed;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    z-index: -1;
    background-image: radial-gradient(circle, var(--secondary-color) 4px, transparent 2.5px);
    background-size: 40px 40px;
    transform: rotate(30deg);
    animation: slideDots 4s linear infinite;
}

@keyframes slideDots {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: 40px 40px;
    }
}
body > * {
  margin: 20px auto;
}
main {
  display: grid;
  grid-template-columns: minmax(min-content, 1fr) 2fr;
  gap: 20px;
  padding: 0 20px;
}
aside {
  position: sticky;
  top: 0;
  background-color: var(--close-background-color);
  padding: 20px;
  border: solid 3px var(--primary-color);
  border-right: 5px solid var(--primary-color);
  border-bottom: 5px solid var(--primary-color);
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: none;

  -ms-overflow-style: none;
}
aside::-webkit-scrollbar {
  display: none;
}

aside h2#cocktails-menu-header {
  margin-bottom: 10px;
  padding: 10px;
  text-align: center;
  border: solid 1px var(--primary-color);
  border-right: 3px solid var(--primary-color);
  border-bottom: 3px solid var(--primary-color);
}
ul#cocktails-list {
  list-style: none;
  padding: 0 10px;
}
li.cocktail-list-item {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 10px;
  padding: 10px;
  border: solid 1px var(--primary-color);
  border-right: 3px solid var(--primary-color);
  border-bottom: 3px solid var(--primary-color);
  cursor: pointer;
}
li.cocktail-list-item:hover {
  font-size: 18px;
  background-color: var(--accent-color);
  border-right: 3px solid var(--secondary-color);
  border-bottom: 3px solid var(--secondary-color);
  font-weight: bold;
}
li.cocktail-list-item img {
  user-select: none;
  width: 30px;
  height: 30px;
  object-fit: cover;
  margin-right: 10px;
}
section#current-cocktail {
  background-color: var(--close-background-color);
  padding: 20px;
  border: solid 3px var(--primary-color);
  border-right: 5px solid var(--primary-color);
  border-bottom: 5px solid var(--primary-color);
  display: flex;
  flex-direction: column;
  align-items: center;
}
section#current-cocktail h1 {
  font-size: 40px;
  margin-bottom: 20px;
  text-align: center;
}
section#current-cocktail img {
  object-fit: cover;
  margin-bottom: 20px;
  border: 2px solid var(--primary-color);
  border-right: 4px solid var(--primary-color);
  border-bottom: 4px solid var(--primary-color);
}
section#current-cocktail p {
  font-size: 18px;
  margin-bottom: 10px;
}
section.ingredients,
section.instructions {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: left;
}
section#current-cocktail h3 {
  font-size: 30px;
  margin-bottom: 10px;
  align-self: center;
}
section.ingredients ul {
  list-style: none;
  padding: 0;
}
section.ingredients li {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  margin-bottom: 5px;
  font-weight: bold;
}
#filter-sort-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

#filters-modal{
  width: 1000px;
margin: 2rem auto auto auto;
height: 300px;

}
#filters-modal::backdrop,
#ingredient-modal::backdrop {
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.5);
  user-select: none;
}
#filters-modal header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0;
}
#filter-button,
#search-button,
#close-ingredient-modal,
#close-filters {
  padding: 10px 30px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 16px;
}
#filters-modal section {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  gap: 20px;
}
#filter-sort-section input {
  height: max-content;
}
body.modal-open {
    overflow: hidden;
}
.sync-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}
#sync{

  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(360deg); }
    100% { transform: rotate(0deg); }

}


.ingredients li div{
  display: flex;
  justify-content: space-between;
  width:300px;
}

.view-ingredient-button {
  padding: 0px 20px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 16px;
}
#ingredient-modal {
  flex-direction: column;
  align-items: center;
  background-color: var(--close-background-color);
  gap:30px;
  width: 400px;
  padding: 20px;
  border: solid 3px var(--primary-color);
  border-right: 5px solid var(--primary-color);
  border-bottom: 5px solid var(--primary-color);
}
#ingredient-modal[open] {
  display: flex;
}   
#ingredient-modal header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}
#ingredient-modal img {
    border: 2px solid var(--primary-color);
  border-right: 4px solid var(--primary-color);
  border-bottom: 4px solid var(--primary-color);
}
.ingredient-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}
.ingredient-details div {
  display: flex;
  gap:20px;
}

@media screen and (max-width: 1023px) {
  main {
    grid-template-columns: 1fr;
  }
  aside {
    position: static;
    height: 400px;
    border: solid 3px var(--primary-color);
    border-right: 5px solid var(--primary-color);
    border-bottom: 5px solid var(--primary-color);
    margin-bottom: 20px;
  }
  #filters-modal {
    width: 90vw;
    height: 40vh;
    margin: 1rem auto;
  }

  #filters-modal section {
    flex-direction: column;
    align-items: flex-start;
  }

  #filter-sort-section {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
}
@media screen and (max-width: 450px) {
  :root {
    font-size: 14px;
  }
  body > * {
    margin: 10px auto;
  }
  main {
    gap: 12px;
    padding: 0 8px;
  }
  aside,
  section#current-cocktail {
    padding: 12px;
  }
  section#current-cocktail h1 {
    font-size: 28px;
  }
  section#current-cocktail h3 {
    font-size: 22px;
  }
  #ingredient-modal {
    width: 90vw;
    padding: 12px;
    gap: 16px;
  }
  #ingredient-modal header {
    padding: 10px;
  }
  #filters-modal {
    width: 90vw;
    height: 50vh;
    margin: 1rem auto;
    padding: 12px;
  }
  #filters-modal section {
    gap: 10px;
  }
  #filter-sort-section {
    gap: 8px;
  }
  #filter-sort-section input,
  #filter-button,
  #search-button {
    width: 100%;
  }
  #filter-button,
  #search-button,
  #close-ingredient-modal,
  #close-filters,
  .view-ingredient-button {
    padding: 8px 12px;
    font-size: 14px;
  }
  .ingredients li {
    gap: 8px;
    align-items: center;
  }
  .ingredients li div {
    width: 200px;
    min-width: 0;
    gap: 8px;
  }
  .ingredients li div p {
    overflow-wrap: anywhere;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB,6CAA6C;AAC7C;;;EAGE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;;EAIE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,iCAAiC;EACjC,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;IACP,kBAAkB;IAClB,iBAAiB;IACjB,6CAA6C;IAC7C,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,WAAW;IACX,wFAAwF;IACxF,0BAA0B;IAC1B,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,8BAA8B;IAClC;AACJ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,+CAA+C;EAC/C,aAAa;EACb,sCAAsC;EACtC,4CAA4C;EAC5C,6CAA6C;EAC7C,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;;EAErB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,4CAA4C;EAC5C,6CAA6C;AAC/C;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,4CAA4C;EAC5C,6CAA6C;EAC7C,eAAe;AACjB;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,8CAA8C;EAC9C,+CAA+C;EAC/C,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,+CAA+C;EAC/C,aAAa;EACb,sCAAsC;EACtC,4CAA4C;EAC5C,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,4CAA4C;EAC5C,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf,2BAA2B;AAC3B,aAAa;;AAEb;AACA;;EAEE,2BAA2B;EAC3B,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;;;;EAIE,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;IACI,KAAK,yBAAyB,EAAE;IAChC,OAAO,uBAAuB,EAAE;;AAEpC;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,+CAA+C;EAC/C,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,4CAA4C;EAC5C,6CAA6C;AAC/C;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;AACA;IACI,sCAAsC;EACxC,4CAA4C;EAC5C,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,sCAAsC;IACtC,4CAA4C;IAC5C,6CAA6C;IAC7C,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,cAAc;EAChB;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,aAAa;IACb,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;;;IAGE,WAAW;EACb;EACA;;;;;IAKE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,QAAQ;IACR,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,QAAQ;EACV;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Add your styles here */\n/* 1. Use a more-intuitive box-sizing model */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* 2. Remove default margin */\n*:not(dialog) {\n  margin: 0;\n}\n\n/* 3. Enable keyword animations */\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  /* 4. Add accessible line-height */\n  line-height: 1.5;\n  /* 5. Improve text rendering */\n  -webkit-font-smoothing: antialiased;\n}\n\n/* 6. Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* 7. Inherit fonts for form controls */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* 8. Avoid text overflows */\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n  cursor: default;\n}\n\n/* 9. Improve line wrapping */\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n/*\n  10. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n}\n\n:root {\n  font-size: 16px;\n  --far-background-color: white;\n  --close-background-color: #eeeeee;\n  --primary-color: #020100;\n  --secondary-color: #801a86;\n  --accent-color: #e768f3;\n}\nbody {\n  font-family: \"Space Grotesk\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  margin: 0;\n    position: relative;\n    min-height: 100vh;\n    background-color: var(--far-background-color);\n    overflow-x: hidden;\n}\nbody::before {\n    content: \"\";\n    position: fixed;\n    top: -50%;\n    left: -50%;\n    width: 200%;\n    height: 200%;\n    z-index: -1;\n    background-image: radial-gradient(circle, var(--secondary-color) 4px, transparent 2.5px);\n    background-size: 40px 40px;\n    transform: rotate(30deg);\n    animation: slideDots 4s linear infinite;\n}\n\n@keyframes slideDots {\n    0% {\n        background-position: 0 0;\n    }\n    100% {\n        background-position: 40px 40px;\n    }\n}\nbody > * {\n  margin: 20px auto;\n}\nmain {\n  display: grid;\n  grid-template-columns: minmax(min-content, 1fr) 2fr;\n  gap: 20px;\n  padding: 0 20px;\n}\naside {\n  position: sticky;\n  top: 0;\n  background-color: var(--close-background-color);\n  padding: 20px;\n  border: solid 3px var(--primary-color);\n  border-right: 5px solid var(--primary-color);\n  border-bottom: 5px solid var(--primary-color);\n  height: 100vh;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n\n  -ms-overflow-style: none;\n}\naside::-webkit-scrollbar {\n  display: none;\n}\n\naside h2#cocktails-menu-header {\n  margin-bottom: 10px;\n  padding: 10px;\n  text-align: center;\n  border: solid 1px var(--primary-color);\n  border-right: 3px solid var(--primary-color);\n  border-bottom: 3px solid var(--primary-color);\n}\nul#cocktails-list {\n  list-style: none;\n  padding: 0 10px;\n}\nli.cocktail-list-item {\n  display: flex;\n  justify-content: space-between;\n  font-size: 16px;\n  margin-bottom: 10px;\n  padding: 10px;\n  border: solid 1px var(--primary-color);\n  border-right: 3px solid var(--primary-color);\n  border-bottom: 3px solid var(--primary-color);\n  cursor: pointer;\n}\nli.cocktail-list-item:hover {\n  font-size: 18px;\n  background-color: var(--accent-color);\n  border-right: 3px solid var(--secondary-color);\n  border-bottom: 3px solid var(--secondary-color);\n  font-weight: bold;\n}\nli.cocktail-list-item img {\n  user-select: none;\n  width: 30px;\n  height: 30px;\n  object-fit: cover;\n  margin-right: 10px;\n}\nsection#current-cocktail {\n  background-color: var(--close-background-color);\n  padding: 20px;\n  border: solid 3px var(--primary-color);\n  border-right: 5px solid var(--primary-color);\n  border-bottom: 5px solid var(--primary-color);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\nsection#current-cocktail h1 {\n  font-size: 40px;\n  margin-bottom: 20px;\n  text-align: center;\n}\nsection#current-cocktail img {\n  object-fit: cover;\n  margin-bottom: 20px;\n  border: 2px solid var(--primary-color);\n  border-right: 4px solid var(--primary-color);\n  border-bottom: 4px solid var(--primary-color);\n}\nsection#current-cocktail p {\n  font-size: 18px;\n  margin-bottom: 10px;\n}\nsection.ingredients,\nsection.instructions {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n}\nsection#current-cocktail h3 {\n  font-size: 30px;\n  margin-bottom: 10px;\n  align-self: center;\n}\nsection.ingredients ul {\n  list-style: none;\n  padding: 0;\n}\nsection.ingredients li {\n  display: flex;\n  justify-content: space-between;\n  font-size: 18px;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n#filter-sort-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n#filters-modal{\n  width: 1000px;\nmargin: 2rem auto auto auto;\nheight: 300px;\n\n}\n#filters-modal::backdrop,\n#ingredient-modal::backdrop {\n  backdrop-filter: blur(10px);\n  background-color: rgba(0, 0, 0, 0.5);\n  user-select: none;\n}\n#filters-modal header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px 0;\n}\n#filter-button,\n#search-button,\n#close-ingredient-modal,\n#close-filters {\n  padding: 10px 30px;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n}\n#filters-modal section {\n  display: flex;\n  justify-content: space-evenly;\n  width: 100%;\n  gap: 20px;\n}\n#filter-sort-section input {\n  height: max-content;\n}\nbody.modal-open {\n    overflow: hidden;\n}\n.sync-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100px;\n}\n#sync{\n\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(360deg); }\n    100% { transform: rotate(0deg); }\n\n}\n\n\n.ingredients li div{\n  display: flex;\n  justify-content: space-between;\n  width:300px;\n}\n\n.view-ingredient-button {\n  padding: 0px 20px;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n}\n#ingredient-modal {\n  flex-direction: column;\n  align-items: center;\n  background-color: var(--close-background-color);\n  gap:30px;\n  width: 400px;\n  padding: 20px;\n  border: solid 3px var(--primary-color);\n  border-right: 5px solid var(--primary-color);\n  border-bottom: 5px solid var(--primary-color);\n}\n#ingredient-modal[open] {\n  display: flex;\n}   \n#ingredient-modal header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n}\n#ingredient-modal img {\n    border: 2px solid var(--primary-color);\n  border-right: 4px solid var(--primary-color);\n  border-bottom: 4px solid var(--primary-color);\n}\n.ingredient-details {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  text-align: center;\n}\n.ingredient-details div {\n  display: flex;\n  gap:20px;\n}\n\n@media screen and (max-width: 1023px) {\n  main {\n    grid-template-columns: 1fr;\n  }\n  aside {\n    position: static;\n    height: 400px;\n    border: solid 3px var(--primary-color);\n    border-right: 5px solid var(--primary-color);\n    border-bottom: 5px solid var(--primary-color);\n    margin-bottom: 20px;\n  }\n  #filters-modal {\n    width: 90vw;\n    height: 40vh;\n    margin: 1rem auto;\n  }\n\n  #filters-modal section {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  #filter-sort-section {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n}\n@media screen and (max-width: 450px) {\n  :root {\n    font-size: 14px;\n  }\n  body > * {\n    margin: 10px auto;\n  }\n  main {\n    gap: 12px;\n    padding: 0 8px;\n  }\n  aside,\n  section#current-cocktail {\n    padding: 12px;\n  }\n  section#current-cocktail h1 {\n    font-size: 28px;\n  }\n  section#current-cocktail h3 {\n    font-size: 22px;\n  }\n  #ingredient-modal {\n    width: 90vw;\n    padding: 12px;\n    gap: 16px;\n  }\n  #ingredient-modal header {\n    padding: 10px;\n  }\n  #filters-modal {\n    width: 90vw;\n    height: 50vh;\n    margin: 1rem auto;\n    padding: 12px;\n  }\n  #filters-modal section {\n    gap: 10px;\n  }\n  #filter-sort-section {\n    gap: 8px;\n  }\n  #filter-sort-section input,\n  #filter-button,\n  #search-button {\n    width: 100%;\n  }\n  #filter-button,\n  #search-button,\n  #close-ingredient-modal,\n  #close-filters,\n  .view-ingredient-button {\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n  .ingredients li {\n    gap: 8px;\n    align-items: center;\n  }\n  .ingredients li div {\n    width: 200px;\n    min-width: 0;\n    gap: 8px;\n  }\n  .ingredients li div p {\n    overflow-wrap: anywhere;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
